import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../../../redux/store.model';
import { Group } from '../../../../../redux/groups/api/group.model';
import { IncidentAPIResponseMVP } from '../../../../../redux/incident/api/Incident.model';
import { getDictionaryGroups } from '../../../../../redux/groups/selectors';
import GroupModel from '../../../../../redux/groups/api/GroupModel';
import { getAlarmsInRegion } from '../../composableDevice/model/SCCGroup.model';

export const getDashboardFilters = (state: RootState) => state.dashboardFilters;
export const getAlarmsSplitRegions = createSelector(
  [
    getDictionaryGroups,
    (_state: RootState, props: { regions: Group[] }) => props.regions,
    (_state: RootState, props: { incidents: IncidentAPIResponseMVP[] }) =>
      props.incidents,
  ],
  (dictionaryGroups, regions, incidents) => {
    const regionsWithIncidents = regions.map((region) => {
      const devicesIds = GroupModel.getAllDevicesIdFromGroups(
        dictionaryGroups,
        undefined,
        region.id
      );
      const alarmsByRegion = getAlarmsInRegion(incidents, devicesIds);
      return [region.id, alarmsByRegion] as const;
    });
    return new Map(regionsWithIncidents);
  }
);
